import axios from '../utils/axios'
let warnApi={
    // 分页获取提醒信息
    getWarnInfo(params, success){
        axios('/warn/getwarninfo', params, success)
    },
    //新增提醒
    addWarn(params, success){
        axios('/warn/addwarn', params, success)
    },
    //修改提醒
    updateWarn(params, success){
        axios('/warn/updatewarn', params, success)
    },
    //删除提醒
    deleteWarn(params, success){
        axios('/warn/deletewarn', params, success)
    }
}
export default warnApi


// WEBPACK FOOTER //
// ./src/api/warn.js